import { ILanguage, LanguagesService } from '@alpha-core/platform-ui';
import { Component, inject } from '@angular/core';
import { PrimeNGModules } from '../../../shared/alpha-shared.module';

@Component({
    selector: 'app-languages',
    standalone: true,
    imports: [...PrimeNGModules],
    templateUrl: './languages.component.html',
})
export class LanguagesComponent {
    languageService = inject(LanguagesService);

    languageList: ILanguage[] | null = [];
    selectedLanguage: ILanguage | undefined;
    dropdownIconClass: string = 'pi pi-chevron-down';
    ngOnInit(): void {
        this.languageService.getLanguageReady$().subscribe({
            next: () => {
                this.languageList = this.languageService.languageList;
                this.selectedLanguage = this.languageService.getLanguage();
            },
            error: (error) => {
                console.error('Unable to fetch languages', error);
            },
        });
    }

    onDropdownOpen() {
        this.dropdownIconClass = 'pi pi-chevron-up';
    }

    onDropdownClose() {
        this.dropdownIconClass = 'pi pi-chevron-down';
    }

    onLanguageChange(value: ILanguage) {
        this.languageService.setLanguage(value);
    }
}
